import React from 'react';
import { PageDefinition } from '../../createRoutes';
import Page from '../../layouts/Page';
import Content from './Content';

export const reportsPage: PageDefinition = {
    path: '/reports',
    Component() {
        return (
            <Page breadcrumbs={{ name: 'Reports' }}>
                <Content />
            </Page>
        );
    },
};
